module.exports = __webpack_public_path__ + "img/dreamdeal.6b4bdb3e.png";